type SwipeIndicatorProps = {
  swipeDirection: 'left' | 'right' | null
  swipeProgress: number
  currentPage: number
}

export const SwipeIndicator = ({ swipeDirection, swipeProgress, currentPage }: SwipeIndicatorProps) => {
  if (!swipeDirection || swipeProgress <= 0) {
    return null
  }

  return (
    <div
      className={`fixed top-1/2 -translate-y-1/2 z-50 transition-opacity ${
        swipeDirection === 'right' ? 'left-4' : 'right-4'
      }`}
      style={{ opacity: swipeProgress }}
    >
      <div className="bg-white/20 backdrop-blur-sm rounded-full p-4 border-2 border-white/40">
        <div className="text-white text-2xl font-bold">{swipeDirection === 'right' ? '←' : '→'}</div>
      </div>
      <div className="text-white text-center mt-2 font-semibold">
        {swipeDirection === 'right' ? `Page ${currentPage - 1}` : `Page ${currentPage + 1}`}
      </div>
    </div>
  )
}
